import { render, staticRenderFns } from "./AllCasesGrid.vue?vue&type=template&id=24f354d9&scoped=true&"
import script from "./AllCasesGrid.vue?vue&type=script&lang=js&"
export * from "./AllCasesGrid.vue?vue&type=script&lang=js&"
import style0 from "./AllCasesGrid.vue?vue&type=style&index=0&id=24f354d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f354d9",
  null
  
)

export default component.exports